export const sessionChart = {
    series: [{
            name: "Number of sessions",
            type: "column",
            // data: [440, 505, 414, 671, 227, 413, 201, 352, 452, 320],
            data: [],
            color: "#78BE20",
        },
        {
            name: "Total usage (MWh)",
            type: "column",
            // data: [350, 200, 500, 360, 485, 523, 380, 100, 200, 296],
            data: [],
            color: "#78BE20",
        },
    ],
    chartOptions: {
        chart: {
            type: 'bar',
            height: 350,
            zoom: {
                enabled: false,
            },
            background: "#0D3937",  // set to dark: allow clear to display in export png
            toolbar: {
                show: true,
                tools: {
                  // replace default dropdown icons with custom ones:
                  download: false,
                },
              },
        },
        colors: ["#78BE20", "#DDF0AC"],  // Explicitly set chart colors
        plotOptions: {
            bar: {
                horizontal: false,
                borderRadius: 1, // bar corner radius to 1: original design is 1
                columnWidth: '55%',
                endingShape: 'rounded'
            },
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        // labels: [
        //     "1",
        //     "2",
        //     "3",
        //     "4",
        //     "5",
        //     "6",
        //     "7",
        //     "8",
        //     "9",
        //     "10",
        // ],
        labels: [],
        xaxis: {
            labels: {
                style: {
                    colors: "#FFFFFF",
                    fontSize: "12px",
                    fontFamily: "Moderat",
                    fontWeight: 400,
                },
            },
        },
        yaxis: [{
                decimalsInFloat: 0,
                tickAmount: 5,
                tickPlacement: "between",
                title: {
                    text: "Number of Session",
                    style: {
                        color: "#FFFFFF",
                        fontSize: "14px",
                        fontWeight: 700,
                        fontFamily: "Moderat",
                    },
                },
                labels: {
                    style: {
                        colors: "#FFFFFF",
                        fontSize: "12px",
                        fontFamily: "Moderat",
                        fontWeight: 400,
                    },
                },
                axisBorder: {
                    show: false,
                    color: "#FFFFFF",
                },
                axisTicks: {
                    show: false,
                    color: "#FFFFFF",
                },
            },
            {
                decimalsInFloat: 0,
                tickAmount: 5,
                tickPlacement: "between",
                labels: {
                    style: {
                        colors: "#FFFFFF",
                        fontSize: "12px",
                        fontFamily: "Moderat",
                        fontWeight: 400,
                    },
                },
                opposite: true,
                title: {
                    text: "Total Usage (MWh)",
                    style: {
                        color: "#FFFFFF",
                        fontSize: "14px",
                        fontWeight: 700,
                        fontFamily: "Moderat",
                    },
                },
                axisBorder: {
                    show: false,
                    color: "#FFFFFF",
                },
                axisTicks: {
                    show: false,
                    color: "#FFFFFF",
                },
            },
        ],
        legend: {
            position: "top",
            labels: {
                colors: "#FFFFFF",
            },
            markers: {
                fillColors: ["#78BE20", "#DDF0AC"],
            },
        },
        fill: {
            opacity: 1
        },
        tooltip: {
            y: [{
                    formatter: function(val) {
                        return val
                    }
                },
                {
                    formatter: function(val) {
                        return val + " MWh"
                    }
                }
            ]
        }
    },
}

export const sessionChartTwo = {
    series: [
        {
            name: "Solar to EV (MWh)",
            type: "column",
            // data: [440, 505, 414, 671, 227, 413, 201, 352, 452, 320],
            data: [],
            color: "#78BE20",
            fillColors: ["#78BE20"],
        },
        {
            name: "Battery to EV (MWh)",
            type: "column",
            // data: [350, 200, 500, 360, 485, 523, 380, 100, 200, 296],
            data: [],
            color: "#DDF0AC",
            fillColors: ["#DDF0AC"],
        },
    ],
    chartOptions: {
        chart: {
            type: 'bar',
            height: 350,
            zoom: {
                enabled: false,
            },
            background: "#0D3937",  // set to dark: allow clear to display in export png
            toolbar: {
                show: true,
                tools: {
                  // replace default dropdown icons with custom ones:
                  download: false,
                },
              },
        },
        colors: ["#78BE20", "#DDF0AC"],  // Explicitly set chart colors
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '55%',
                endingShape: 'rounded',
                dataLabels : {
                    position: "top",
                }
            },
        },
        dataLabels: {
            enabled: true,
            offsetY: -10,
            style: {
                fontSize: "9px",
            }
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        labels: [],
        xaxis: {
            labels: {
                rotate: -35,
                style: {
                    colors: "#FFFFFF",
                    fontSize: "12px",
                    fontFamily: "Moderat",
                    fontWeight: 400,
                    rotateAlways: true,
                    hideOverlappingLabels: true,
                },
            },
        },
        yaxis: [
            {
                seriesName: 'Solar to EV (MWh)',
                decimalsInFloat: 0,
                tickAmount: 5,
                tickPlacement: "between",
                title: {
                    text: "Solar to EV (MWh)",
                    style: {
                        color: "#FFFFFF",
                        fontSize: "14px",
                        fontWeight: 700,
                        fontFamily: "Moderat",
                    },
                },
                labels: {
                    style: {
                        colors: "#FFFFFF",
                        fontSize: "12px",
                        fontFamily: "Moderat",
                        fontWeight: 400,
                    },
                },
                axisBorder: {
                    show: false,
                    color: "#FFFFFF",
                },
                axisTicks: {
                    show: false,
                    color: "#FFFFFF",
                },
            },
            {
                seriesName: 'Battery to EV (MWh)',
                opposite: true,
                decimalsInFloat: 0,
                tickAmount: 5,
                tickPlacement: "between",
                title: {
                    text: "Battery to EV (MWh)",
                    style: {
                        color: "#FFFFFF",
                        fontSize: "14px",
                        fontWeight: 700,
                        fontFamily: "Moderat",
                    },
                },
                labels: {
                    style: {
                        colors: "#FFFFFF",
                        fontSize: "12px",
                        fontFamily: "Moderat",
                        fontWeight: 400,
                    },
                },
                axisBorder: {
                    show: false,
                    color: "#FFFFFF",
                },
                axisTicks: {
                    show: false,
                    color: "#FFFFFF",
                },
            }
        ],
        legend: {
            position: "top",
            labels: {
                colors: "#FFFFFF",
            },
            markers: {
                fillColors: ["#78BE20", "#DDF0AC"],
            },
        },
        fill: {
            opacity: 1
        },
        tooltip: {
            y: [
                {
                    formatter: function(val) {
                        return val + " MWh"
                    }
                },
                {
                    formatter: function(val) {
                        return val + " MWh"
                    }
                },
            ]
        }
    },
}